import { render, staticRenderFns } from "./ClassicalMusic.vue?vue&type=template&id=4a02fc7c&scoped=true&"
import script from "./ClassicalMusic.vue?vue&type=script&lang=js&"
export * from "./ClassicalMusic.vue?vue&type=script&lang=js&"
import style0 from "./ClassicalMusic.vue?vue&type=style&index=0&id=4a02fc7c&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a02fc7c",
  null
  
)

export default component.exports